<script lang="ts">
    import {_} from 'svelte-i18n'
    import List, {Item, Meta, PrimaryText, SecondaryText, Text} from '@smui/list';
    import Button from '@smui/button';
    import {Label} from '@smui/common';
    import {userService} from './services';
    import type {User} from './types';
    import {onMount} from 'svelte';

    let users: User[] = [];

	async function createUser() {
		await userService.createUser();
		await refreshUsers();
	}

	async function editUser(user: User) {
		await userService.editUser(user);
		await refreshUsers();
	}

	async function unblockUser(user: User) {
		await userService.unblockUser(user.id);
		await refreshUsers();
	}

	async function deleteUser(user: User) {
		await userService.deleteUser(user.id);
		await refreshUsers();
	}

	async function refreshUsers() {
		users = await userService.fetchUsers();
        users = users.sort((a, b) => a.username.localeCompare(b.username));
	}

	onMount(async () => await refreshUsers());
</script>

<div style="display: flex; justify-content: space-between;">
    <div class="mdc-typography--headline4">{$_('user.settings.UserSettings')}</div>
    <Button on:click={() => createUser()} variant="unelevated"><Label>{$_('user.settings.CreateNew')}</Label></Button>
</div>

<div style="margin: 10px 0 10px 0;">
    <List twoLine>
        {#each users as user (user.id)}
            <Item>
                <Text>
                    <PrimaryText>
                        {user.username}
                    </PrimaryText>
                    <SecondaryText>
                        <span>
                            {#if user.operator}{$_('user.Consultant')}{/if}
                            {#if user.intervisor}{$_('user.Intervisor')}{/if}
                            {#if user.admin}{$_('user.Administrator')}{/if}
                        </span>
                        <span style="color:red;">
                            {#if user.loginLimitExceeded}{$_('user.auth.IncorrectLoginLimitExceeded')}{/if}
                        </span>
                    </SecondaryText>
                </Text>
                <Meta class="material-icons">
                    {#if user.loginLimitExceeded}
                        <Button on:click={() => unblockUser(user)} variant="unelevated"><Label>{$_('user.auth.ToUnblock')}</Label></Button>
                    {/if}
                    <Button on:click={() => editUser(user)} variant="unelevated"><Label>{$_('commons.Edit')}</Label></Button>
                    <Button on:click={() => deleteUser(user)} variant="unelevated"><Label>{$_('commons.Delete')}</Label></Button>
                </Meta>
            </Item>
        {/each}
    </List>
</div>